module.exports = __webpack_public_path__ + "media/role_selection/cashier-0ec617b8.png";